<template>
<div class="bg-white p-3">
	<form @submit.prevent="login($event)" method="post" class="needs-validation" novalidate>
		<div class="mb-3">
            <label for="email" class="form-label">YOUR EMAIL:</label>
            <input v-model="account.email" required type="email" class="form-control" id="email" aria-describedby="emailHelp">
        </div>
        <div class="mb-3">
            <label for="password" class="form-label">PASSWORD:</label>
            <input v-model="account.password" required type="password" class="form-control" id="password">
        </div>
        <div class="mb-3">
        	<a href="/password_reset/">Forgot your password?</a>
        </div>
        <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="remember">
            <label class="form-check-label" for="remember">REMEMBER ME</label>
        </div>
        <button type="submit" class="btn btn-info" id="login-btn">Log In</button>
	</form>
</div>	
</template>

<script>
import axios from 'axios';

export default {
	name: 'LoginForm',
	data() {
	  	return {
	  		account: {
				email: "",
				password: "",
			},
		}
	},
	methods:{
	  	async login(event){
        	var t = this;

        	if (!event.target.checkValidity()) return;
            
        	let params = this.account;
        	params.action = 'login';

        	var data = await t.makeRequest("/new_account/", params);
        	if (data.success) {
        		t.$emit('setStep', 2);
        	}
        	else {
        		/*global customValidation*/
        		customValidation.showError("Sorry, wrong email or password");
        	}
	    },
	    makeRequest(url, params){
        	return axios.post(url, params)
            .then((res) => {
              return res.data;
            })
            .catch(() => {
            	// error.response.status Check status code
            }).finally(() => {
            	//Perform action in always
            });
        },
	}
}
</script>
